import { useEffect } from 'react';
import { forceReloadResources } from '../utils/cache-buster';

export const useCacheBuster = () => {
  useEffect(() => {
    // Forcer le rechargement des ressources au montage du composant
    forceReloadResources();
  }, []);
}; 